// src/modules/app-views/products/pages/Ai/modals/InfoModal/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import GenericModal from 'components/core/GenericModal';
import infoModalStep from './Step1';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const InfoModal = ({ show, setShow, afterClose }) => {
  // ---------------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------------
  const handleFinish = async () => {
    // Informational modal - just close on confirm
    return true;
  };

  // ---------------------------------------------------------------------------
  // LOCAL VARIABLES
  // ---------------------------------------------------------------------------
  const steps = useMemo(() => [infoModalStep()], []);

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <GenericModal
      show={show}
      setShow={setShow}
      icon={<InfoCircleOutlined />}
      title="how_to_catalog_products_with_ai"
      steps={steps}
      onFinish={handleFinish}
      afterClose={afterClose}
      width={600}
      maskClosable={true}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default InfoModal;
